/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Before_DepartureInputs */

const fr_marker_before_departure = /** @type {(inputs: Marker_Before_DepartureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`avant-départ`)
};

const en_marker_before_departure = /** @type {(inputs: Marker_Before_DepartureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`before departure`)
};

/**
* | output |
* | --- |
* | "before departure" |
*
* @param {Marker_Before_DepartureInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_before_departure = /** @type {((inputs?: Marker_Before_DepartureInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Before_DepartureInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_before_departure(inputs)
	return en_marker_before_departure(inputs)
});